// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"56406dcb","141":"aa2cd350","432":"56406dcb","538":"fed7600a","555":"56406dcb","561":"56406dcb","643":"21e956ec","726":"9a70c5d4","801":"56406dcb","960":"b555a26b"}[chunkId] + ".css";
};